.page {
  min-height: 100vh;
  background: var(--color-background);
  color: var(--color-foreground);
}

.main {
  width: min(100%, 1120px);
  margin: 0 auto;
  padding: 8rem 2rem 6rem;
}

// Index

.index {
  display: grid;
  gap: 2.5rem;
}

.indexHeader {
  display: grid;
  gap: 1rem;
  max-width: 760px;
}

.lead {
  max-width: 680px;
  font-size: 1.125rem;
  line-height: 1.6;
}

.grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1.5rem;
}

// Post cards

.card {
  display: grid;
  grid-template-rows: auto 1fr;
  overflow: hidden;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  background: var(--color-card);
  color: inherit;
  text-decoration: none;
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease;

  &:hover {
    border-color: var(--color-primary-border);
    box-shadow: 0 12px 32px -18px color-mix(in srgb, var(--color-foreground) 35%, transparent);
  }
}

.cardCover {
  border-bottom: 1px solid var(--color-border);
}

.cardBody {
  display: grid;
  align-content: start;
  gap: 0.625rem;
  padding: 1.5rem;
}

.cardTitle {
  margin: 0;
  text-wrap: balance;

  .card:hover & {
    color: var(--color-primary);
  }
}

.featuredCard {
  grid-template-columns: minmax(0, 1.2fr) minmax(0, 1fr);
  grid-template-rows: none;

  .cardCover {
    height: 100%;
    border-inline-end: 1px solid var(--color-border);
    border-bottom: 0;
  }

  .cardBody {
    align-content: center;
    gap: 0.875rem;
    padding: 2.5rem;
  }
}

.meta {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin: 0;
  color: var(--color-muted-foreground);
  font-size: 0.875rem;
}

// Post

.post {
  max-width: 760px;
  margin: 0 auto;
}

.backLink {
  display: inline-flex;
  margin-bottom: 2rem;
  align-items: center;
  justify-self: start;
  gap: 0.375rem;
  color: var(--color-muted-foreground);
  font-size: 0.9rem;
  font-weight: 500;
  text-decoration: none;

  &:hover {
    color: var(--color-primary);
  }
}

.postDetails {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding-top: 1.25rem;
  border-top: 1px solid var(--color-border);
}

.tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin: 0;
  padding: 0;
  list-style: none;
}

.postCover {
  margin-bottom: 3rem;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
}

.more {
  display: grid;
  gap: 1.5rem;
  margin-top: 5rem;
  padding-top: 3rem;
  border-top: 1px solid var(--color-border);
}

@media (max-width: 768px) {
  .main {
    padding: 6.5rem 1rem 4rem;
  }

  .grid,
  .featuredCard {
    grid-template-columns: minmax(0, 1fr);
  }

  .featuredCard {
    grid-template-rows: auto 1fr;

    .cardCover {
      height: auto;
      border-inline-end: 0;
      border-bottom: 1px solid var(--color-border);
    }

    .cardBody {
      padding: 1.5rem;
    }
  }
}
